import IDiceAdvanceSearch from '../types/IDiceAdvanceSearch';

export default {
  skills: {
    values: [],
    matchType: 'AND',
  },
  jobTitle: {
    values: [],
    matchType: 'AND',
  },
  companies: {
    values: [],
    matchType: 'AND',
  },
  totalExperience: {
    min: '',
    max: '',
  },
  excludeSocialOnlyProfiles: true,
  contactMethod: ['email'],
  likelyToMove: -1,
  education: [],
  languages: [],
  additionalFilters: ['excludeThirdParty'],
  resumeLastUpdated: '',
  employmentType: [],
  authorizedCountries: [],
  workAuthorization: [],
  salaryRange: {
    currency: '',
    unitTime: '',
    min: '',
    max: '',
  },
  hasSecurityClearance: null,
  willingToRelocate: null,
  willingToRelocatePreferredLocationsOnly: null,
  willingToRelocateIncludeLocals: null,
  travelPreference: -1,
} as IDiceAdvanceSearch;
